import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LoadingService } from './core/services/loading.service';
import {PosthogService} from "./core/services/posthog.service";
import { OnlineStatusService } from './core/services/online-status.service';
import { SettingService } from './core/services/setting.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  globalLoading = this.loadingService.loadingState;
  isOnline = this.onlineStatusService.online$;
  title = 'BangCoffee';
  customDomainData: any;
  hostnameUrl = '';
  private routerSubscription!: Subscription;

  constructor(
    private loadingService: LoadingService,
    private ph: PosthogService,
    private onlineStatusService: OnlineStatusService,
    private settingService: SettingService,
    private router: Router
  ) {
    this.ph.init();
  }

  ngOnInit(): void {
    this.getCustomDomain().then();

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.getCustomDomain().then();
    });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  async getCustomDomain(): Promise<void> {
    try {
      const response = await this.settingService.getCustomDomain();
      console.log(response);
      if (response?.success &&
        response.data.status === 'active' &&
        response.data.sslStatus === 'active') {
        const data = response.data;
        this.customDomainData = data;
        const hostname = data?.hostname;
        this.hostnameUrl = hostname ? `https://${hostname}` : environment.previewLink;
      } else {
        this.hostnameUrl = environment.previewLink;
      }
    } catch (error) {
      this.hostnameUrl = environment.previewLink;
    } finally {
      this.settingService.setHostnameUrl(this.hostnameUrl);
    }
  }
}
